import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LineFloatingButton from '../../components/feature/LineFloatingButton';
import GreetingHeroSection from './components/GreetingHeroSection';
import GreetingMessageSection from './components/GreetingMessageSection';
import GreetingSocialSection from './components/GreetingSocialSection';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const greetingJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  url: `${SITE_URL}/greeting`,
  name: '東京シニア婚活相談所 代表挨拶 | 縁結び 和はは',
  description: '東京のシニア婚活相談所「縁結び和はは」代表からのご挨拶。婚活東京シニア専門で50代・60代・70代の婚活に寄り添う想いと東京シニア婚活への大切な想いをお伝えします。',
  author: {
    '@type': 'Person',
    name: '縁結び和はは 代表',
    worksFor: {
      '@type': 'LocalBusiness',
      name: '縁結び 和はは',
      url: SITE_URL,
    },
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ホーム', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: '代表挨拶', item: `${SITE_URL}/greeting` },
    ],
  },
};

export default function GreetingPage() {
  return (
    <>
      <SeoHead
        title="代表挨拶 | 東京シニア婚活相談所 縁結び 和はは"
        description="東京のシニア婚活相談所「縁結び和はは」代表からのご挨拶。婚活東京シニア専門で50代・60代・70代の婚活に寄り添う想いと東京シニア婚活への大切な想いをお伝えします。"
        keywords="東京 シニア 婚活, 婚活相談所 代表 東京, シニア婚活カウンセラー, 縁結び和はは代表, 60代婚活サポート東京"
        path="/greeting"
        jsonLd={greetingJsonLd}
      />
      <Navbar />
      <main>
        <GreetingHeroSection />
        <GreetingMessageSection />
        <GreetingSocialSection />
      </main>
      <Footer />
      <LineFloatingButton />
    </>
  );
}
